import { isLeft } from 'fp-ts/lib/Either';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { FileInput as FileInputBase } from '../FileInput';

interface Props {
  className?: string;
  label: string;
  maxSize?: number;
  name?: string;
}

export function FileInput(props: Props) {
  const [error, setError] = useState('');

  return (
    <label className={twMerge('block', 'w-full', props.className)}>
      <div className="grid gap-x-2 items-center grid-cols-[max-content_1fr]">
        <div className="font-bold text-white text-sm">{props.label}</div>
        {error && (
          <div className="truncate text-right text-rose-500 text-sm">
            {error}
          </div>
        )}
      </div>
      <FileInputBase
        className="mt-1"
        maxSize={props.maxSize}
        name={props.name}
        onChange={(e) => {
          if (isLeft(e)) {
            setError(e.left.message);
          } else {
            setError('');
          }
        }}
      />
    </label>
  );
}
